var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsDownload = function SvgInterfaceActionsDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C9.683 2 9 2.683 9 3.5V10H4.586L12 17.414 19.414 10H15V3.5c0-.817-.683-1.5-1.5-1.5zm.5 2h2v8h1.586L12 14.586 9.414 12H11zM2 20v2h20v-2z"
  })));
};
export default SvgInterfaceActionsDownload;